import { forwardRef, Text, TextProps } from '@chakra-ui/react';

export const LectureCardTitle = forwardRef<TextProps, 'p'>(({ children, ...rest }, ref) => {
  return (
    <Text as="h3" fontFamily="heading" fontWeight="bold" fontSize="16px" lineHeight="24px" {...rest} ref={ref}>
      {children}
    </Text>
  );
});
